import { mallDomain, cashierDomain } from '@/defines/domains'
export const nativeRoutes = {
  // 首页
  home: {
    app: 'mall://index',
    mp: '/pages/home/index/index',
    isTab: true
  },
  // 首页清单
  homePurchase: {
    app: 'mall://purchase-list',
    mp: '/pages/home/index/index' // 小程序没有首页清单，暂且按首页走
  },
  // 消息中心
  messageCenter: {
    app: 'mall://message/center'
  },
  // 全部菜品
  goodsList: {
    app: 'mall://market',
    mp: '/pages/allGoods/index',
    isTab: true
  },
  // 商品详情页，注意一定要加参数！！！！！！
  goodsDetail: {
    app: 'mall://goods/detail',
    mp: '/pages/goods/detail/index'
  },
  // 搜索
  search: {
    app: 'mall://goods/search',
    mp: '/packageProducts/pages/search/index'
  },
  // 常用清单
  purchase: {
    app: 'mall://purchase',
    mp: '/pages/purchase/index',
    isTab: true
  },
  // 购物车
  cart: {
    app: 'mall://shopcart',
    mp: '/pages/cart/subCart/index' // 老逻辑的时候，跳小程序购物车都跳的是没 tab 的那个，暂且沿用
  },
  // 不带 tab 且有返回的购物车
  pureCart: {
    app: 'mall://newShopcart',
    mp: '/pages/cart/subCart/index'
  },
  // 个人中心
  profile: {
    app: 'mall://profile',
    mp: '/pages/mine/index',
    isTab: true
  },
  // 订单列表
  orderList: {
    app: 'mall://order/index',
    mp: '/packageTrade/pages/order/list/index'
  },
  // 订单详情 - 要传 order id!
  orderDetail: {
    app: 'mall://order/detail',
    mp: '/pages/order/detail/index'
  },
  // 优惠券
  myCoupons: {
    app: 'mall://coupon/mine',
    mp: '/packageUser/pages/mineCoupon/index'
  },
  // 提交新品需求
  newGoodRequest: {
    app: 'mall://user/need/upload',
    mp: '', // TODO: 这个是 h5，拼个 webview
    h5: `${mallDomain}/marketing/#/new-good-req/list`
  },
  // 服务中心
  serviceCenter: {
    app: 'mall://user/service',
    mp: '' // TODO: 这个也是 h5，拼个 webview
  },
  // 在线客服（智齿）
  sobot: {
    app: 'mall://user/sobot',
    mp: '', // TODO: ??
    h5: '' // TODO: h5 有这个吗？
  },
  // 发票
  invoice: {
    app: 'mall://user/invoice',
    mp: '', // TODO: 这个也是 h5，拼个 webview
    h5: `${mallDomain}/#/invoice`
  },
  // 钱包
  wallet: {
    app: 'mall://user/wallet',
    mp: '', // TODO: 这个也是 h5，拼个 webview
    h5: `${cashierDomain}/prepay/index`
  },
  // 登录
  login: {
    app: 'mall://account/login',
    mp: '/packageAccount/pages/entrance/authLogin/index'
  },
  // 设置
  settings: {
    app: 'mall://account/set',
    mp: '/packageUser/pages/setting/index' // TODO:
  },
  // webview，暂时只有小程序
  webview: {
    app: '',
    mp: '/pages/common/webView/index',
    h5: ''
  },
  // 申请美白条
  iOUsApply: {
    app: 'mall://iqus/apply'
  },
  // 美白条申请结果
  iOUsApplyResult: {
    app: 'mall://iqus/auditResults'
  },
  // 美白条激活
  iOUsActivate: {
    app: 'mall://iqus/activate'
  },
  // 美白条重置密码：
  iOUsResetPassword: {
    app: 'mall://iqus/resetPassword'
  },
  // 美白条换绑卡
  iOUsRebindCard: {
    app: 'mall://iqus/rebind'
  },
  // 内容产品（菜谱）二级页
  contentList: {
    h5: `${mallDomain}/marketing/#/content_list`
  },
  demandWordRank: {
    h5: `${mallDomain}/marketing/#/demand-word-rank`
  },
  // 内容产品（菜谱）我的关注
  contentAttention: {
    h5: `${mallDomain}/marketing/#/content_attention`
  },
  // 内容产品（菜谱）我的主页
  contentMyPage: {
    h5: `${mallDomain}/marketing/#/content_my_page`
  },
  // 内容产品（菜谱）他人主页
  contentOtherPage: {
    h5: `${mallDomain}/marketing/#/content_other_page`
  },
  // 内容产品（菜谱）图文详情
  contentPicTextDetail: {
    app: 'mall://food/contentDetail',
    mp: '/packageActivity/pages/dishesDetail/index'
  },
  // 内容产品（菜谱）视频详情
  contentVideoDetail: {
    app: 'mall://food/videoDetail',
    mp: '/packageActivity/pages/videoDetail/index'
  },
  // IM页
  newIm: {
    app: 'mall://user/im',
    mp: '/packageUser/pages/newIM/index'
  },
  // 原生收银台 paySecret：支付秘钥 agentId: 收银台id
  cashier: {
    app: 'mall://pay/cashier',
    mp: '/packageAccount/pages/finance/cashierPay/index'
  }
}

export const nativeRoutesKeys = Object.keys(nativeRoutes).sort(
  (a, b) => a.length - b.length
)

export const appUrlIndex = (() => {
  const index = {}
  Object.entries(nativeRoutes).forEach(([key, value]) => {
    value.app && (index[value.app] = key)
  })
  return index
})()

export const miniProgramUrlIndex = (() => {
  const index = {}
  Object.entries(nativeRoutes).forEach(([key, value]) => {
    value.wxmp && (index[value.wxmp] = key)
  })
  return index
})()

export const h5UrlIndex = (() => {
  const index = {}
  Object.entries(nativeRoutes).forEach(([key, value]) => {
    value.h5 && (index[value.h5] = key)
  })
  return index
})()
